/* eslint-disable deprecation/deprecation */
/* eslint-disable @typescript-eslint/no-this-alias */
import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { forEachRight, range } from 'lodash';
import { isNullOrUndefined } from 'is-what';

declare let XLSX;

@Directive()
@Injectable()
export class XlsxToJsonService {
  public isFileCorrupted = false;
  public sheetsNameWithColumnCount: any;
  public excelContent: any;
  @Output() checkPasswordProtected = new EventEmitter<string>();

  // parseExcelFile(evt):Observable<any>{
  //   var files = evt.target.files;
  //     var i, f, endRow;
  //     let parsedData = [];
  //     let badFile: boolean = false;
  //     let fileCorrupted: boolean = false;
  //         f = files[0];
  //         var reader = new FileReader();
  //         var name = f.name;
  //         let workbook;
  //         let sheet;
  //         let structureDataSheet;
  //         let shelfNumber = "";
  //         let settlementDate = "";
  //         return Observable.create(observer =>{
  //           reader.onload = function (evt) {
  //             var wbdata = evt.target['result'];
  //             var binary = "";
  //             var bytes = new Uint8Array(wbdata);
  //             var length = bytes.byteLength;
  //             for (var i = 0; i < length; i++) {
  //               binary += String.fromCharCode(bytes[i]);
  //             }
  //             try {
  //             workbook = XLSX.read(binary,{
  //               type: 'binary'
  //             });
  //             if ( workbook && workbook.Props && (workbook.Props.Application === 'Microsoft Excel' || workbook.Props.ApplicationName === 'Microsoft Excel')){
  //               sheet = workbook.Sheets['ErrorReport'];
  //               structureDataSheet = workbook.Sheets['Structure Data'];

  //               if(sheet != null && structureDataSheet != null ){
  //                 if(!isNullOrUndefined(sheet['!ref'])){
  //                 var range = XLSX.utils.decode_range(sheet['!ref']);
  //                 endRow = range.e.r;
  //                 var new_range = ({s: {c:0, r:0}, e: {c:4,r:endRow}});
  //                 parsedData = XLSX.utils.sheet_to_json(sheet, {raw: true,header:0, range: new_range});
  //                 }
  //                 if(structureDataSheet.C6 != null && structureDataSheet.C6 != undefined){
  //                   shelfNumber = structureDataSheet.C6.v;
  //                 }
  //                 if(structureDataSheet.C8 != null && structureDataSheet.C8 != undefined){
  //                  if (structureDataSheet.C8.t=="s"){
  //                   settlementDate = structureDataSheet.C8.v;
  //                  }else{
  //                   settlementDate = structureDataSheet.C8.w;
  //                  }
  //                 }

  //               }else{
  //                 badFile = true;
  //               }
  //             } else {
  //               fileCorrupted = true;
  //             }

  //           }catch(exp){
  //               console.log(exp);
  //             }
  //             observer.next([parsedData, badFile, fileCorrupted, shelfNumber.trim(), settlementDate.trim()]);
  //               observer.complete();
  //         };
  //         reader.readAsArrayBuffer(f);
  //       })
  // }

  parseExcelFile(evt): Observable<any> {
    const files = evt.target.files;
    let endRow;
    let parsedData = [];
    let badFile = false;
    let fileCorrupted = false;
    let structuredParsedData = [];
    const f = files[0];
    const reader = new FileReader();
    let workbook;
    let sheet;
    let structureDataSheet;
    let shelfNumber = '';
    let settlementDate = '';
    return new Observable((observer) => {
      reader.onload = function (event) {
        const wbdata = event.target.result;
        let binary = '';
        const bytes = new Uint8Array(wbdata as ArrayBuffer);
        const length = bytes.byteLength;
        for (let k = 0; k < length; k++) {
          binary += String.fromCharCode(bytes[k]);
        }
        try {
          workbook = XLSX.read(binary, {
            type: 'binary',
          });
          if (
            workbook &&
            workbook.Props &&
            (workbook.Props.Application === 'Microsoft Excel' ||
              workbook.Props.ApplicationName === 'Microsoft Excel')
          ) {
            sheet = workbook.Sheets.ErrorReport;
            structureDataSheet = workbook.Sheets['Structure Data'];

            if (sheet != null && structureDataSheet != null) {
              if (
                !(isNullOrUndefined(sheet['!ref']) && isNullOrUndefined(structureDataSheet['!ref']))
              ) {
                const range2 = XLSX.utils.decode_range(sheet['!ref']);
                endRow = range2.e.r;
                const newRange2 = { s: { c: 0, r: 0 }, e: { c: 4, r: endRow } };
                parsedData = XLSX.utils.sheet_to_json(sheet, {
                  raw: true,
                  header: 0,
                  range: newRange2,
                });
                const sdRange = XLSX.utils.decode_range(structureDataSheet['!ref']);
                structuredParsedData = XLSX.utils.sheet_to_json(structureDataSheet, {
                  raw: true,
                  header: 11,
                  range: { s: { c: 1, r: 11 }, e: { c: 8, r: sdRange.e.r } },
                });
              }
              if (structureDataSheet.C6 != null && structureDataSheet.C6 !== undefined) {
                shelfNumber = structureDataSheet.C6.v;
              }
              if (structureDataSheet.C8 != null && structureDataSheet.C8 !== undefined) {
                if (structureDataSheet.C8.t === 's') {
                  settlementDate = structureDataSheet.C8.v;
                } else {
                  settlementDate = structureDataSheet.C8.w;
                }
              }
            } else {
              badFile = true;
            }
          } else {
            fileCorrupted = true;
          }
        } catch (exp) {
          console.log(exp);
        }
        observer.next([
          parsedData,
          badFile,
          fileCorrupted,
          shelfNumber.trim(),
          settlementDate.trim(),
          structuredParsedData,
        ]);
        observer.complete();
      };
      reader.readAsArrayBuffer(f);
    });
  }

  public processFileToJson(object, file, headers?): Observable<any> {
    const reader = new FileReader();
    const _this = this;
    let workbook;
    return new Observable((observer) => {
      reader.onload = (e) => {
        const data = e.target.result;
        try {
          workbook = XLSX.read(data, {
            type: 'binary',
          });
        } catch (exp) {
          console.log(exp);
          this.checkPasswordProtected.emit(exp.message);
        }

        object.sheets = _this.parseWorksheet(workbook, true, true, headers);
        observer.next(object);
        observer.complete();
      };
      reader.readAsBinaryString(file);
    });
  }

  parseWorksheet(workbook, readCells, toJSON, headers?) {
    this.checkIfFileIsCorrupted(workbook);
    const _this = this;
    _this.getExcelSheetsData(workbook);
    if (toJSON === true) {
      return this.toJson(workbook, headers);
    }
    const sheets = {};
    forEachRight(workbook.SheetNames, function (sheetName) {
      const sheet = workbook.Sheets[sheetName];
      sheets[sheetName] = _this.parseSheet(sheet, readCells);
    });
    return sheets;
  }

  parseSheet(sheet, readCells) {
    if (!isNullOrUndefined(sheet['!ref'])) {
      const sheetRange = XLSX.utils.decode_range(sheet['!ref']);
      const sheetData = [];

      if (readCells === true) {
        forEachRight(range(sheetRange.s.r, sheetRange.e.r + 1), function (row) {
          const rowData = [];
          forEachRight(range(sheetRange.s.c, sheetRange.e.c + 1), function (column) {
            const cellIndex = XLSX.utils.encode_cell({
              c: column,
              r: row,
            });
            const cell = sheet[cellIndex];
            rowData[column] = cell ? cell.v : undefined;
          });
          sheetData[row] = rowData;
        });
      }

      return {
        sheet: sheetData,
        name: sheet.name,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        col_size: sheetRange.e.c + 1,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        row_size: sheetRange.e.r + 1,
      };
    }
  }

  toJson(workbook, headers?) {
    const result = {};
    let roa = [];
    this.sheetsNameWithColumnCount = [];
    workbook.SheetNames.forEach(function (sheetName) {
      const sheet = workbook.Sheets[sheetName];
      this.findSheetsNameWithColumnCount(sheet, sheetName);
      if (headers) {
        roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: headers,
          skipHeader: true,
          origin: -1,
        });
      } else {
        roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      }
      if (roa.length > 0) {
        result[sheetName] = roa;
      }
    }, this);
    this.setSheetsNameWithColumnCount(this.sheetsNameWithColumnCount);
    return result;
  }

  public checkIfFileIsCorrupted(workbook) {
    if (
      workbook &&
      workbook.Props &&
      (workbook.Props.Application === 'Microsoft Excel' ||
        workbook.Props.ApplicationName === 'Microsoft Excel')
    ) {
      this.setIsFileCOrrupted(false);
    } else {
      this.setIsFileCOrrupted(true);
    }
  }

  public setIsFileCOrrupted(value: boolean) {
    this.isFileCorrupted = value;
  }

  public getIsFileCOrrupted(): boolean {
    return this.isFileCorrupted;
  }

  public findSheetsNameWithColumnCount(sheet, sheetName): any {
    const sheetRange = !isNullOrUndefined(sheet['!ref'])
      ? XLSX.utils.decode_range(sheet['!ref']).e.c
      : 0;
    this.sheetsNameWithColumnCount.push(sheetRange + '@' + sheetName);
  }

  public getExcelSheetsData(workbook): any {
    const sheets = {};
    const _this = this;
    workbook.SheetNames.forEach((sheetName) => {
      const sheet = workbook.Sheets[sheetName];
      sheets[sheetName] = _this.parseSheet(sheet, true);
    });
    this.setExcelContent(sheets);
    return sheets;
  }

  public getSheetsNameWithColumnCount(): any {
    return this.sheetsNameWithColumnCount;
  }

  public setSheetsNameWithColumnCount(sheetsNameWithColumnCount: any) {
    this.sheetsNameWithColumnCount = sheetsNameWithColumnCount;
  }

  public getExcelContent(): any {
    return this.excelContent;
  }

  public setExcelContent(excelContent: any) {
    this.excelContent = excelContent;
  }
}
